import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { moduloGaritas } from '../../diccionarios/balanzaModulo.js';
import { NotaMaquilaService } from '../../services/nota-maquila.service';
import * as printJS from 'print-js';


@Component({
  selector: 'app-nota-maquila',
  templateUrl: './nota-maquila.component.html',
  styleUrls: ['./nota-maquila.component.css']
})
export class NotaMaquilaComponent implements OnInit {

  titulo: string = "Parametrización PLC Perform";

  formulario: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;


  textBoton: string;
  textoBuscar: string;

  mostrarFormulario = false;
  editableForm = false;

  tvcModulo: any = {};


  loading: boolean = false;
  listaVacia: boolean = true;

  public DAT_TITULOS: any = moduloGaritas.titulos.notaMaquila;
  URI: string = 'PARAMETRIZACION - PLC - PERFORM';

  constructor(
    private fb: FormBuilder,
    private _util: UtilsService,
    private servicioMaquila: NotaMaquilaService
  ) {
  }

  ngOnInit() {
    //this.servicioSeguimiento.saveSeguimiento(this.URI);
    this.tvcModulo = moduloGaritas;
    //this.DAT_BTNS = this.tvcModulo.button.buttonsNombre;
    //this.DAT_MSG = this.tvcModulo.mensajes;
    //this.DAT_BTNCSS = this.tvcModulo.button.buttonsCss;
    //this.textBoton = this.tvcModulo.button.buttonsNombre.guardar;
    this.formulario = this.fb.group({
      ordBalanza: ['', [Validators.required, Validators.maxLength(16)]]
    });

  }


  imprimirTicket() {
    this.loading = true;
    this.servicioMaquila.imprimir(this.formulario.get('ordBalanza').value).subscribe(
      resp => {
        this.loading = false;
        if (resp) {
          this._util.descargarArchivo("Nota-Maquila-" + this.formulario.get('ordBalanza').value + ".pdf", resp);
          // printJS({
          //   printable: resp,
          //   type: 'pdf',
          //   base64: true
          // });
          return;
        }
        this._util.mensajeErroToast('No se pudo imprimir correctamente.');
      },
      error => {
        this.loading = false;
        this._util.mensajeErroToast(error.mensaje);
      }
    );
  }


  acciones(event) {
    // debugger
    if (event === "guardar") {
      if (this.editableForm) {
        // this.actualizar();
      } else {
        //this.guardar();
      }
    } else {
      //this.regresar();
    }
  }

  /**
   * * SERVICIOS
   */


}
